import { createBrowserHistory, History } from 'history';

export interface CustomHistory extends History {
  goToCards: Function;
  goToReports: Function;
  goToLogin: Function;
  goToEmployeeLogin: Function;
  goToLogout: Function;
}

const configureHistory = () => {
  const history = createBrowserHistory() as CustomHistory;

  history.goToCards = function (params?: { from: string }) {
    this.push('/cards', params);
  };

  history.goToReports = function () {
    this.push('/reports');
  };

  history.goToLogin = function () {
    this.push('/login');
  };

  history.goToEmployeeLogin = function () {
    this.push('/employeeLogin');
  };

  history.goToLogout = function () {
    this.push('/logout');
  };

  return history;
};

export default configureHistory();
